import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.pos.business');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-pos-business',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.pos.business/view.scss */
:host {
  display: block;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.sub-screen {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.sub-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: var(--pos-panel);
  border-bottom: 1px solid var(--pos-border);
  flex-shrink: 0;
}

.back-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid var(--pos-border);
  background: transparent;
  color: var(--pos-text-dim);
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 150ms;
}
.back-btn:hover {
  background: var(--pos-card);
  color: var(--pos-text);
}
.back-btn:active {
  transform: scale(0.94);
}

.sub-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: var(--pos-text);
}

.section-badge {
  font-size: 12px;
  font-weight: 500;
  padding: 4px 10px;
  background: var(--pos-accent);
  color: #fff;
  border-radius: 12px;
}

.sub-body {
  flex: 1;
  padding: 20px;
}

.biz-section {
  animation: fadeIn 200ms ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.closing-card, .form-card, .summary-card {
  background: var(--pos-panel);
  border-radius: 10px;
  padding: 16px;
  border: 1px solid var(--pos-border);
  margin-bottom: 12px;
}

.compact-card {
  align-self: start;
}
.compact-card .card-value {
  font-size: 18px;
  font-weight: 600;
  color: var(--pos-text);
}

.card-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--pos-text);
  margin: 0 0 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--pos-border);
}

.info-table {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
  min-height: 32px;
}
.info-row.total-row {
  border-top: 1px solid var(--pos-border);
  padding-top: 10px;
  margin-top: 4px;
  font-weight: 600;
}
.info-row.denom-header {
  border-bottom: 1px solid var(--pos-border);
  padding-bottom: 6px;
  margin-bottom: 2px;
  font-size: 11px;
  font-weight: 600;
  color: var(--pos-text-dim);
}
.info-row .denom-count {
  width: 80px;
  text-align: center;
  flex-shrink: 0;
}
.info-row .denom-amount {
  width: 100px;
  text-align: right;
  flex-shrink: 0;
  font-size: 12px;
  color: var(--pos-text-dim);
}

.info-label {
  font-size: 13px;
  color: var(--pos-text-dim);
  min-width: 70px;
  flex-shrink: 0;
}

.info-value {
  font-size: 13px;
  color: var(--pos-text);
  font-weight: 500;
  text-align: right;
  flex: 1;
}
.info-value.accent {
  color: var(--pos-accent);
  font-weight: 600;
}

.text-red {
  color: #ef4444 !important;
}

.text-green {
  color: #22c55e !important;
}

.num-input, input[type=text], input[type=password], input[type=date], input[type=time], select {
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text);
  font-size: 13px;
  text-align: right;
  min-width: 0;
  flex: 1;
  max-width: 200px;
}
.num-input:focus, input[type=text]:focus, input[type=password]:focus, input[type=date]:focus, input[type=time]:focus, select:focus {
  outline: none;
  border-color: var(--pos-accent);
  box-shadow: 0 0 0 2px rgba(74, 158, 255, 0.15);
}

.denom-header ~ .info-row .num-input {
  flex: 0 0 80px;
  max-width: 80px;
}

input[type=date], input[type=time] {
  text-align: left;
}

.form-actions {
  display: flex;
  gap: 8px;
  margin-top: 14px;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.biz-btn {
  padding: 8px 18px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid var(--pos-border);
  transition: all 150ms;
  white-space: nowrap;
}
.biz-btn.primary {
  background: var(--pos-accent);
  border-color: var(--pos-accent);
  color: #fff;
}
.biz-btn.primary:hover {
  filter: brightness(1.1);
}
.biz-btn.outline {
  background: transparent;
  color: var(--pos-text);
}
.biz-btn.outline:hover {
  background: var(--pos-hover);
}
.biz-btn.danger {
  background: #ef4444;
  border-color: #ef4444;
  color: #fff;
}
.biz-btn.danger:hover {
  filter: brightness(1.1);
}
.biz-btn:active {
  transform: scale(0.96);
}
.biz-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  filter: none;
  transform: none;
}

.closing-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid var(--pos-border);
}

.table-wrap {
  overflow-x: auto;
  margin-top: 8px;
}

.pos-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.pos-table th {
  background: var(--pos-card);
  color: var(--pos-text-dim);
  font-weight: 600;
  padding: 8px 10px;
  text-align: left;
  white-space: nowrap;
  border-bottom: 1px solid var(--pos-border);
}
.pos-table td {
  padding: 7px 10px;
  color: var(--pos-text);
  border-bottom: 1px solid var(--pos-border);
  white-space: nowrap;
}
.pos-table tr:hover td {
  background: var(--pos-hover);
}
.pos-table .text-right {
  text-align: right;
}
.pos-table .text-center {
  text-align: center;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 150ms ease;
}

.modal-box {
  background: var(--pos-panel);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.modal-box.modal-sm {
  width: 380px;
}
.modal-box.modal-lg {
  width: 700px;
}
.modal-box.modal-xl {
  width: 900px;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  border-bottom: 1px solid var(--pos-border);
}
.modal-header h3 {
  font-size: 15px;
  font-weight: 600;
  margin: 0;
  color: var(--pos-text);
}

.close-btn {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: none;
  background: transparent;
  color: var(--pos-text-dim);
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.close-btn:hover {
  background: var(--pos-hover);
}

.modal-body {
  padding: 18px;
  overflow-y: auto;
  flex: 1;
}
.modal-body.text-center {
  text-align: center;
}

.modal-footer {
  padding: 12px 18px;
  border-top: 1px solid var(--pos-border);
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.msg {
  font-size: 14px;
  color: var(--pos-text);
  line-height: 1.7;
  padding: 12px 0;
}

.close-confirm-error {
  margin-top: 10px;
  padding: 8px 12px;
  border-radius: 6px;
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
  font-size: 13px;
  text-align: center;
}

.close-confirm-notice {
  margin-bottom: 10px;
  padding: 8px 12px;
  border-radius: 6px;
  background: rgba(245, 158, 11, 0.12);
  color: #d97706;
  font-size: 13px;
  text-align: center;
}

.del-btn {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid var(--pos-border);
  background: transparent;
  color: var(--pos-text-dim);
  font-size: 11px;
  cursor: pointer;
}
.del-btn:hover {
  background: #ef4444;
  color: #fff;
  border-color: #ef4444;
}

.week-closing-bar {
  background: var(--pos-panel);
  border-radius: 10px;
  padding: 14px 16px;
  border: 1px solid var(--pos-border);
  margin-bottom: 14px;
}

.week-closing-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.week-closing-title-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.week-closing-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--pos-text);
}

.week-closing-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.week-closing-selected {
  font-size: 12px;
  font-weight: 600;
  color: var(--pos-text);
}

.week-closing-range {
  font-size: 11px;
  color: var(--pos-text-dim);
}

.week-closing-state {
  font-size: 11px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 999px;
  background: var(--pos-hover);
  color: var(--pos-text-dim);
}
.week-closing-state.closed {
  background: rgba(34, 197, 94, 0.12);
  color: #16a34a;
}
.week-closing-state.opened {
  background: rgba(245, 158, 11, 0.14);
  color: #d97706;
}
.week-closing-state.not-opened {
  background: rgba(148, 163, 184, 0.16);
  color: var(--pos-text-dim);
}

.week-closing-picker {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text);
  cursor: pointer;
  overflow: hidden;
  flex-shrink: 0;
  transition: all 150ms;
  appearance: none;
}
.week-closing-picker:hover {
  background: var(--pos-hover);
}

.week-closing-picker-input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}

.week-closing-picker-text {
  font-size: 12px;
  font-weight: 600;
}

.week-closing-picker-icon {
  width: 16px;
  height: 16px;
  color: var(--pos-accent);
  flex-shrink: 0;
}

.week-closing-days {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  padding-bottom: 2px;
}

.week-day {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  padding: 8px 4px;
  border-radius: 8px;
  border: 2px solid var(--pos-border);
  background: var(--pos-card);
  cursor: pointer;
  transition: all 150ms;
  min-width: 0;
}
.week-day.not-opened {
  opacity: 0.4;
  cursor: default;
}
.week-day.not-opened .day-status {
  color: var(--pos-text-dim);
}
.week-day.opened {
  border-color: #f59e0b;
}
.week-day.opened .day-status {
  color: #f59e0b;
  font-weight: 600;
}
.week-day.closed {
  border-color: #22c55e;
}
.week-day.closed .day-status {
  color: #22c55e;
  font-weight: 600;
}
.week-day.selected {
  border-color: var(--pos-accent);
  background: rgba(74, 158, 255, 0.08);
  box-shadow: 0 0 0 2px rgba(74, 158, 255, 0.2);
}
.week-day:hover:not(.not-opened) {
  background: var(--pos-hover);
}
.week-day:active:not(.not-opened) {
  transform: scale(0.96);
}

@media (max-width: 760px) {
  .week-closing-head {
    flex-direction: column;
    align-items: stretch;
  }
  .week-closing-picker {
    justify-content: center;
  }
  .week-day {
    min-width: 72px;
  }
}
.day-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--pos-text);
}

.day-date {
  font-size: 10px;
  color: var(--pos-text-dim);
}

.day-status {
  font-size: 10px;
  color: var(--pos-text-dim);
  font-weight: 500;
}

.modal-box.modal-calendar {
  width: min(1040px, 100vw - 32px);
}

.closing-calendar-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 14px;
}

.calendar-summary-card {
  background: var(--pos-card);
  border: 1px solid var(--pos-border);
  border-radius: 10px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.calendar-summary-label {
  font-size: 12px;
  color: var(--pos-text-dim);
  font-weight: 500;
}

.calendar-summary-value {
  font-size: 15px;
  color: var(--pos-text);
  font-weight: 700;
}

.closing-calendar-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(320px, 0.95fr);
  gap: 16px;
}

.closing-calendar-panel,
.closing-calendar-detail {
  background: var(--pos-card);
  border: 1px solid var(--pos-border);
  border-radius: 12px;
  padding: 14px;
}

.closing-calendar-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
}

.calendar-nav-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid var(--pos-border);
  background: var(--pos-panel);
  color: var(--pos-text);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 150ms;
}
.calendar-nav-btn:hover:not(:disabled) {
  background: var(--pos-hover);
}
.calendar-nav-btn:disabled {
  opacity: 0.35;
  cursor: default;
}

.closing-calendar-month {
  font-size: 15px;
  font-weight: 700;
  color: var(--pos-text);
}

.closing-calendar-legend {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.calendar-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  color: var(--pos-text-dim);
}

.calendar-legend-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: var(--pos-border);
}

.calendar-legend-item.success .calendar-legend-dot {
  background: #22c55e;
}

.calendar-legend-item.warning .calendar-legend-dot {
  background: #f59e0b;
}

.calendar-legend-item.muted .calendar-legend-dot {
  background: #94a3b8;
}

.closing-calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 8px;
}

.closing-calendar-weekday {
  text-align: center;
  font-size: 11px;
  font-weight: 700;
  color: var(--pos-text-dim);
  padding: 4px 0;
}

.closing-calendar-day {
  min-height: 104px;
  border-radius: 12px;
  border: 1px solid var(--pos-border);
  background: var(--pos-panel);
  padding: 10px;
  text-align: left;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: all 150ms;
}
.closing-calendar-day:hover {
  background: var(--pos-hover);
  transform: translateY(-1px);
}
.closing-calendar-day.is-selected {
  border-color: var(--pos-accent);
  box-shadow: 0 0 0 2px rgba(74, 158, 255, 0.16);
}
.closing-calendar-day.is-closed {
  border-color: rgba(34, 197, 94, 0.36);
}
.closing-calendar-day.is-opened {
  border-color: rgba(245, 158, 11, 0.42);
}
.closing-calendar-day.is-unopened {
  opacity: 0.8;
}
.closing-calendar-day.is-future {
  opacity: 0.55;
}

.closing-calendar-day.is-empty {
  min-height: 104px;
  border-radius: 12px;
  border: 1px dashed rgba(148, 163, 184, 0.2);
  background: transparent;
}

.closing-calendar-day-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.calendar-day-number {
  font-size: 16px;
  font-weight: 700;
  color: var(--pos-text);
}

.calendar-day-status,
.calendar-detail-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  padding: 4px 8px;
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
  background: rgba(148, 163, 184, 0.14);
  color: var(--pos-text-dim);
}
.calendar-day-status.success,
.calendar-detail-status.success {
  background: rgba(34, 197, 94, 0.14);
  color: #16a34a;
}
.calendar-day-status.warning,
.calendar-detail-status.warning {
  background: rgba(245, 158, 11, 0.16);
  color: #d97706;
}
.calendar-day-status.info,
.calendar-detail-status.info {
  background: rgba(74, 158, 255, 0.14);
  color: var(--pos-accent);
}
.calendar-day-status.muted,
.calendar-detail-status.muted {
  background: rgba(148, 163, 184, 0.14);
  color: var(--pos-text-dim);
}

.closing-calendar-day-body {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.calendar-day-metric {
  font-size: 11px;
  color: var(--pos-text-dim);
  font-weight: 500;
}

.calendar-detail-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
}

.calendar-detail-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: var(--pos-text);
}

.calendar-detail-sub {
  margin: 4px 0 0;
  font-size: 12px;
  color: var(--pos-text-dim);
}

.calendar-detail-metrics {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 14px;
}

.calendar-detail-metric {
  background: var(--pos-panel);
  border: 1px solid var(--pos-border);
  border-radius: 10px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.metric-label {
  font-size: 11px;
  color: var(--pos-text-dim);
  font-weight: 600;
}

.metric-value {
  font-size: 15px;
  color: var(--pos-text);
  font-weight: 700;
}

.calendar-detail-section {
  margin-top: 14px;
}

.calendar-detail-heading {
  margin: 0 0 8px;
  font-size: 12px;
  font-weight: 700;
  color: var(--pos-text-dim);
}

.calendar-checklist {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.calendar-check-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  border: 1px solid var(--pos-border);
  border-radius: 10px;
  background: var(--pos-panel);
  padding: 10px 12px;
}
.calendar-check-item.is-done {
  border-color: rgba(34, 197, 94, 0.28);
}

.calendar-check-mark {
  width: 22px;
  height: 22px;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.14);
  color: var(--pos-text-dim);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 800;
  flex-shrink: 0;
}

.calendar-check-item.is-done .calendar-check-mark {
  background: rgba(34, 197, 94, 0.14);
  color: #16a34a;
}

.calendar-check-content {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.calendar-check-label {
  font-size: 12px;
  color: var(--pos-text);
  font-weight: 700;
}

.calendar-check-meta {
  font-size: 11px;
  color: var(--pos-text-dim);
}

.calendar-issues {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.calendar-issue {
  border: 1px solid var(--pos-border);
  border-radius: 10px;
  background: var(--pos-panel);
  padding: 10px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  text-align: left;
  cursor: default;
}
.calendar-issue.warning {
  border-color: rgba(245, 158, 11, 0.3);
}
.calendar-issue.success {
  border-color: rgba(34, 197, 94, 0.3);
}
.calendar-issue.info {
  border-color: rgba(74, 158, 255, 0.28);
}
.calendar-issue.muted {
  border-color: rgba(148, 163, 184, 0.24);
}
.calendar-issue:disabled {
  opacity: 1;
}
.calendar-issue:not(:disabled) {
  cursor: pointer;
}

.calendar-issue-label {
  font-size: 12px;
  color: var(--pos-text);
  font-weight: 600;
}

.calendar-issue-action {
  font-size: 11px;
  color: var(--pos-accent);
  font-weight: 700;
  white-space: nowrap;
}

.closing-calendar-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid var(--pos-border);
}

@media (max-width: 980px) {
  .closing-calendar-layout {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 720px) {
  .closing-calendar-summary {
    grid-template-columns: 1fr;
  }
  .closing-calendar-grid {
    gap: 6px;
  }
  .closing-calendar-day,
  .closing-calendar-day.is-empty {
    min-height: 88px;
    padding: 8px;
  }
  .calendar-day-status {
    padding: 3px 6px;
    font-size: 9px;
  }
  .calendar-detail-metrics {
    grid-template-columns: 1fr 1fr;
  }
  .closing-calendar-actions {
    flex-direction: column;
  }
}
.closing-complete-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #22c55e;
  color: #fff;
  font-size: 28px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
}

.closing-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.closing-col {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.gift-type-toggle {
  display: flex;
  gap: 4px;
  margin-bottom: 10px;
}
.gift-type-toggle button {
  padding: 5px 14px;
  border-radius: 6px;
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text-dim);
  font-size: 12px;
  cursor: pointer;
}
.gift-type-toggle button.active {
  background: var(--pos-accent);
  border-color: var(--pos-accent);
  color: #fff;
}

.closing-summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
}

.check-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
}

.credit-layout {
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 16px;
}
@media (max-width: 900px) {
  .credit-layout {
    grid-template-columns: 1fr;
  }
}

.credit-search-btns {
  display: flex;
  gap: 4px;
  margin-bottom: 10px;
}
.credit-search-btns button {
  padding: 5px 14px;
  border-radius: 6px;
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text-dim);
  font-size: 12px;
  cursor: pointer;
}
.credit-search-btns button.active {
  background: var(--pos-accent);
  border-color: var(--pos-accent);
  color: #fff;
}

.search-input-row {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}
.search-input-row input {
  flex: 1;
  max-width: none;
  text-align: left;
}

.credit-pay-methods {
  display: flex;
  gap: 4px;
  margin-top: 10px;
  flex-wrap: wrap;
}
.credit-pay-methods button {
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text-dim);
  font-size: 12px;
  cursor: pointer;
}
.credit-pay-methods button.active {
  background: var(--pos-accent);
  border-color: var(--pos-accent);
  color: #fff;
}

.credit-history-actions {
  display: flex;
  gap: 6px;
  margin-top: 10px;
  justify-content: flex-end;
}

.date-range-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}
.date-range-row input {
  max-width: 160px;
  flex: 1;
}
.date-range-row span {
  font-size: 13px;
  color: var(--pos-text-dim);
}

.seller-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  max-width: 700px;
}
@media (max-width: 700px) {
  .seller-layout {
    grid-template-columns: 1fr;
  }
}

.driver-layout {
  display: grid;
  grid-template-columns: 1fr 1fr 1.2fr;
  gap: 12px;
}
@media (max-width: 900px) {
  .driver-layout {
    grid-template-columns: 1fr;
  }
}

.cashio-layout {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 16px;
}
@media (max-width: 800px) {
  .cashio-layout {
    grid-template-columns: 1fr;
  }
}

.cashio-type-btns {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.cashio-type-btn {
  flex: 1;
  padding: 14px;
  border-radius: 8px;
  border: 2px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  text-align: center;
  transition: all 150ms;
}
.cashio-type-btn.active {
  border-color: var(--pos-accent);
  background: rgba(74, 158, 255, 0.08);
  color: var(--pos-accent);
}
.cashio-type-btn:hover:not(.active) {
  background: var(--pos-hover);
}

.cashio-filter {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.cashio-filter input {
  max-width: 160px;
}
.cashio-filter span {
  font-size: 13px;
  color: var(--pos-text-dim);
}

.gift-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.gift-carousel {
  background: var(--pos-panel);
  border-radius: 10px;
  padding: 12px;
  border: 1px solid var(--pos-border);
}

.carousel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.carousel-header span {
  font-size: 13px;
  color: var(--pos-text);
  font-weight: 500;
}

.carousel-arrow {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text-dim);
  font-size: 12px;
  cursor: pointer;
}
.carousel-arrow:hover:not(:disabled) {
  background: var(--pos-hover);
}
.carousel-arrow:disabled {
  opacity: 0.3;
  cursor: default;
}

.carousel-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 8px;
}
@media (max-width: 700px) {
  .carousel-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.gift-item {
  padding: 12px 8px;
  border-radius: 8px;
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  cursor: pointer;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 4px;
  transition: all 150ms;
}
.gift-item:hover {
  border-color: var(--pos-accent);
  background: rgba(74, 158, 255, 0.05);
}
.gift-item:active {
  transform: scale(0.96);
}

.gift-name {
  font-size: 11px;
  color: var(--pos-text);
  font-weight: 500;
  line-height: 1.3;
}

.gift-face {
  font-size: 13px;
  color: var(--pos-accent);
  font-weight: 600;
}

.gift-main {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 12px;
}
@media (max-width: 800px) {
  .gift-main {
    grid-template-columns: 1fr;
  }
}

.gift-table-area, .gift-pay-area {
  background: var(--pos-panel);
  border-radius: 10px;
  padding: 14px;
  border: 1px solid var(--pos-border);
}

.gift-pay-tabs {
  display: flex;
  gap: 4px;
  margin-bottom: 10px;
}
.gift-pay-tabs button {
  padding: 5px 14px;
  border-radius: 6px;
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text-dim);
  font-size: 12px;
  cursor: pointer;
}
.gift-pay-tabs button.active {
  background: var(--pos-accent);
  border-color: var(--pos-accent);
  color: #fff;
}

.gift-pay-info, .gift-pay-history {
  padding: 4px 0;
}

.gift-bottom-actions {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: center;
  padding: 12px;
  background: var(--pos-panel);
  border-radius: 10px;
  border: 1px solid var(--pos-border);
}

.approval-filters {
  display: flex;
  gap: 16px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}

.filter-group {
  display: flex;
  gap: 4px;
}
.filter-group button {
  padding: 5px 12px;
  border-radius: 6px;
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text-dim);
  font-size: 12px;
  cursor: pointer;
}
.filter-group button.active {
  background: var(--pos-accent);
  border-color: var(--pos-accent);
  color: #fff;
}

.dashboard-section {
  background: var(--pos-panel);
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid var(--pos-border);
}

.dash-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  flex-wrap: wrap;
  gap: 10px;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: var(--pos-text);
  margin: 0;
}

.chart-type-btns, .period-btns {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.chart-type-btns button, .period-btns button {
  padding: 7px 14px;
  border-radius: 6px;
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text-dim);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 150ms;
  white-space: nowrap;
}
.chart-type-btns button.active, .period-btns button.active {
  background: var(--pos-accent);
  border-color: var(--pos-accent);
  color: #fff;
}
.chart-type-btns button:hover:not(.active), .period-btns button:hover:not(.active) {
  background: var(--pos-hover);
  color: var(--pos-text);
}

.period-btns {
  margin-bottom: 18px;
}

.chart-area {
  min-height: 260px;
}

.bar-chart-wrapper {
  display: flex;
  gap: 0;
  height: 260px;
}

.bar-y-axis {
  width: 48px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  padding-bottom: 28px;
}
.bar-y-axis .y-label {
  font-size: 9px;
  color: var(--pos-text-dim);
  text-align: right;
  padding-right: 8px;
  line-height: 1;
}

.bar-chart-inner {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.bar-chart-area {
  flex: 1;
  position: relative;
  min-height: 0;
  border-bottom: 1px solid var(--pos-border);
}

.grid-lines {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}
.grid-lines .grid-line {
  position: absolute;
  left: 0;
  right: 0;
  border-bottom: 1px dashed var(--pos-border);
  opacity: 0.35;
}

.bar-columns {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  align-items: flex-end;
  gap: 6px;
  padding: 0 4px;
}

.bar-col {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  min-width: 0;
  position: relative;
}

.bar-fill {
  width: 55%;
  max-width: 44px;
  border-radius: 4px 4px 0 0;
  min-height: 2px;
  background: linear-gradient(180deg, #6db3ff 0%, #3b82f6 50%, #2563eb 100%);
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.15);
  transition: height 400ms cubic-bezier(0.22, 1, 0.36, 1);
}

.bar-val {
  font-size: 10px;
  color: var(--pos-text);
  font-weight: 600;
  margin-bottom: 4px;
  white-space: nowrap;
}

.bar-labels {
  height: 28px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 0 4px;
  gap: 6px;
}

.bar-label {
  flex: 1;
  text-align: center;
  font-size: 11px;
  color: var(--pos-text-dim);
  font-weight: 500;
}

.line-chart-wrapper {
  position: relative;
}

.line-chart {
  width: 100%;
  height: 220px;
  display: block;
}

.line-labels {
  display: flex;
  justify-content: space-between;
  padding: 8px 20px 0;
}
.line-labels span {
  font-size: 11px;
  color: var(--pos-text-dim);
  font-weight: 500;
}

.pie-container {
  display: flex;
  align-items: center;
  gap: 32px;
  justify-content: center;
  padding: 10px 0;
}

.pie-donut-wrap {
  position: relative;
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pie-chart {
  width: 200px;
  height: 200px;
  transform: rotate(-90deg);
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.08));
}

.donut-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.donut-center .donut-label {
  font-size: 11px;
  color: var(--pos-text-dim);
  font-weight: 500;
}
.donut-center .donut-value {
  font-size: 18px;
  font-weight: 700;
  color: var(--pos-text);
}

.pie-legend {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 200px;
  overflow-y: auto;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background 100ms;
}
.legend-item:hover {
  background: var(--pos-hover);
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 3px;
  flex-shrink: 0;
}

.legend-text {
  font-size: 12px;
  color: var(--pos-text);
  font-weight: 500;
  flex: 1;
  min-width: 0;
}

.legend-pct {
  font-size: 12px;
  color: var(--pos-accent);
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

@media (max-width: 768px) {
  .pie-container {
    flex-direction: column;
  }
}`],
})
export class PagePosBusinessComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) {}

    // ═══════ 공통 ═══════
    public currentSection = '';
    public activeModal = '';
    private menuActionHandler: any;

    // ─── Chart ───
    public chartTypes = [
        { key: 'bar', label: '막대 그래프' },
        { key: 'line', label: '꺾은선 그래프' },
        { key: 'pie', label: '원 그래프' },
    ];
    public selectedChart = 'bar';
    public periods = [
        { key: 'daily', label: '일자별 (1주간)' },
        { key: 'weekly', label: '요일별 (4주간)' },
        { key: 'monthly', label: '월별 (1년간)' },
    ];
    public selectedPeriod = 'daily';
    public chartData: { label: string; value: number }[] = [];
    public maxValue = 0;

    // ═══════ 마감정산 ═══════
    public closingPage = 1;
    public closingOpenTime = '';
    public closingCashEtc = '';
    public closingCash50000 = '';
    public closingCash10000 = '';
    public closingCash5000 = '';
    public closingCash1000 = '';
    public closingCash500 = '';
    public closingCash100 = '';
    public closingCash50 = '';
    public closingCash10 = '';
    get closingCashTotal(): number {
        return (parseInt(this.closingCashEtc) || 0)
            + (parseInt(this.closingCash50000) || 0) * 50000
            + (parseInt(this.closingCash10000) || 0) * 10000
            + (parseInt(this.closingCash5000) || 0) * 5000
            + (parseInt(this.closingCash1000) || 0) * 1000
            + (parseInt(this.closingCash500) || 0) * 500
            + (parseInt(this.closingCash100) || 0) * 100
            + (parseInt(this.closingCash50) || 0) * 50
            + (parseInt(this.closingCash10) || 0) * 10;
    }
    public denomAmount(count: string, unit: number): number {
        return (parseInt(count) || 0) * unit;
    }
    public closingPrepCash = 0;
    public closingCashSales = 0;
    public closingCashReturn = 0;
    get closingCashNetSales(): number { return this.closingCashSales - this.closingCashReturn; }
    get closingExpectedCash(): number { return this.closingPrepCash + this.closingCashNetSales; }
    get closingCashDiff(): number { return this.closingCashTotal - this.closingExpectedCash; }
    public closingCardApproval = 0;
    public closingCardCancel = 0;
    get closingCardSales(): number { return this.closingCardApproval - this.closingCardCancel; }
    public closingGiftType: 'normal' | 'electronic' = 'normal';
    public closingGiftCollect = 0;
    public closingGiftRefund = 0;
    get closingGiftBalance(): number { return this.closingGiftCollect - this.closingGiftRefund; }
    public closingGiftDiff = 0;
    public closeConfirmId = '';
    public closeConfirmPw = '';
    public closeConfirmNotice = '';
    public closeConfirmError = '';

    // 승인내역
    public approvalFilter = '전체';
    public approvalTypeFilter = '전체';
    public approvalList: any[] = [];

    // 마감정산 2페이지 데이터 (DB에서 계산)
    public closingSummary1: any[] = [];
    public closingSummary2: any[] = [];
    public closingPayMethod: any[] = [];
    public closingDiscount: any[] = [];
    public closingCardCompany: any[] = [];
    public closingMemberSales: any[] = [];
    public closingNonSales: any[] = [];
    public closingChannelSales: any[] = [];

    // ═══════ 마감현황 ═══════
    public weekClosingStatus: any[] = [];
    public selectedClosingDate = '';
    public closingCompleteDate = '';
    public closingCalendarMonth = '';
    public closingCalendarSelectedDate = '';
    public closingCalendarDays: any[] = [];
    public closingCalendarSummary: any = { pending: 0, closed: 0, unopened: 0, future: 0 };
    public closingCalendarWeekdays = ['일', '월', '화', '수', '목', '금', '토'];

    // ═══════ 준비금등록 ═══════
    public prepDate = '';
    public prepRound = '1';
    public prepSeller = '';
    public prepAmount = '';

    // ═══════ 시재점검 ═══════
    public checkCashEtc = '';
    public checkCash50000 = '';
    public checkCash10000 = '';
    public checkCash5000 = '';
    public checkCash1000 = '';
    public checkCash500 = '';
    public checkCash100 = '';
    public checkCash50 = '';
    public checkCash10 = '';
    get checkCashTotal(): number {
        return (parseInt(this.checkCashEtc) || 0)
            + (parseInt(this.checkCash50000) || 0) * 50000
            + (parseInt(this.checkCash10000) || 0) * 10000
            + (parseInt(this.checkCash5000) || 0) * 5000
            + (parseInt(this.checkCash1000) || 0) * 1000
            + (parseInt(this.checkCash500) || 0) * 500
            + (parseInt(this.checkCash100) || 0) * 100
            + (parseInt(this.checkCash50) || 0) * 50
            + (parseInt(this.checkCash10) || 0) * 10;
    }
    public checkSalesTotal = 0;
    public checkSalesDiscount = 0;
    public checkSalesReturn = 0;
    get checkNetSales(): number { return this.checkSalesTotal - this.checkSalesDiscount - this.checkSalesReturn; }
    public checkPayCash = 0;
    public checkPayCard = 0;
    public checkPayGift = 0;
    public checkPayCredit = 0;
    public checkPayEtc = 0;
    get checkCashBalance(): number { return this.checkPayCash + (parseInt(this.prepAmount) || 0) - this.checkCashTotal; }

    // ═══════ 사원근태 ═══════
    public attCard = '';
    public attNo = '';
    public attPw = '';
    public attName = '';
    public attStaffId = '';
    public attLastStatus = '';

    // ═══════ 마감취소 ═══════
    public cancelDate = '';
    public cancelTime = '';
    public cancelSeller = '';
    public cancelPw = '';

    // ═══════ 외상입금 ═══════
    public creditSearchType: 'card' | 'phone' | 'name' = 'card';
    public creditSearchValue = '';
    public creditMemberId = 0;
    public creditMemberName = '';
    public creditMemberPhone = '';
    public creditMemberBalance = 0;
    public creditAmount = '';
    public creditPayMethod = '';
    public creditRecentHistory: any[] = [];
    public creditDateStart = '';
    public creditDateEnd = '';
    public creditRangeHistory: any[] = [];

    // ═══════ 판매원변경 ═══════
    public sellerOldNo = '';
    public sellerOldName = '';
    public sellerNewNo = '';
    public sellerNewPw = '';
    public sellerNewName = '';
    public sellerNewRole = 'staff';

    // ═══════ 기사출금 ═══════
    public driverSearchName = '';
    public driverSearchCar = '';
    public driverSearchPhone = '';
    public driverId = 0;
    public driverName = '';
    public driverCar = '';
    public driverPhone = '';
    public driverMobile = '';
    public driverReceiptDate = '';
    public driverReceiptNo = '';
    public driverBizDate = '';
    public driverPosNo = '';
    public driverReceiptNoInfo = '';
    public driverPayAmount = 0;
    public driverWithdrawAmount = 0;
    public driverDayHistory: any[] = [];

    // ═══════ 시재입출금 ═══════
    public cashIOType: 'in' | 'out' = 'in';
    public cashIOAmount = '';
    public cashIOAccount = '';
    public cashIOMemo = '';
    public cashIODate = '';
    public cashIORound = '1';
    public cashIOHistory: any[] = [];

    // ═══════ 상품권판매 ═══════
    public giftCertTypes: any[] = [];
    public giftCarouselPage = 0;
    get giftCarouselMax(): number { return Math.ceil(this.giftCertTypes.length / 6) - 1; }
    get giftCarouselItems(): any[] {
        const start = this.giftCarouselPage * 6;
        return this.giftCertTypes.slice(start, start + 6);
    }
    public giftCart: { no: number; name: string; face: number; qty: number; discount: number; amount: number; memo: string }[] = [];
    get giftCartTotal(): number { return this.giftCart.reduce((s, i) => s + i.amount, 0); }
    get giftCartDiscount(): number { return this.giftCart.reduce((s, i) => s + i.discount, 0); }
    get giftCartPayable(): number { return this.giftCartTotal - this.giftCartDiscount; }
    public giftPaidAmount = 0;
    get giftChange(): number { return Math.max(0, this.giftPaidAmount - this.giftCartPayable); }
    public giftPayHistory: any[] = [];
    public giftPayTab: 'info' | 'history' = 'info';

    // ═══════ Lifecycle ═══════
    public async ngOnInit() {
        await this.service.init();
        this.menuActionHandler = (e: any) => { this.handleMenuAction(e.detail.action); };
        document.addEventListener('pos-menu-action', this.menuActionHandler);
        await this.loadChartData();
        this.initDates();

        // 미마감 경고에서 바로가기로 진입 시 자동 섹션 전환
        const autoSection = localStorage.getItem('pos-auto-section');
        if (autoSection) {
            localStorage.removeItem('pos-auto-section');
            if (autoSection === 'closing') {
                await this.handleMenuAction('마감정산');
            }
        }

        await this.service.render();
    }

    ngOnDestroy() {
        if (this.menuActionHandler) document.removeEventListener('pos-menu-action', this.menuActionHandler);
    }

    private initDates() {
        const today = this.getTodayStr();
        this.prepDate = today;
        this.cancelDate = today;
        this.cashIODate = today;
        this.driverReceiptDate = today;
        this.creditDateStart = today;
        this.creditDateEnd = today;
        const now = new Date();
        this.closingOpenTime = `${today} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;
        this.cancelTime = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
        const auth = this.getAuthInfo();
        if (auth) {
            this.prepSeller = `${auth.id} - ${auth.name}`;
            this.cancelSeller = `${auth.id} - ${auth.name}`;
            this.sellerOldNo = auth.id;
            this.sellerOldName = auth.name;
        }
    }

    private getTodayStr(): string {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    }

    private getAuthInfo(): { id: string; name: string } | null {
        try {
            const raw = localStorage.getItem('pos-auth');
            if (raw) return JSON.parse(raw);
        } catch (e) {}
        return null;
    }

    private getBusinessDay(): any {
        try {
            const raw = localStorage.getItem('pos-business-day');
            if (raw) return JSON.parse(raw);
        } catch (e) {}
        return null;
    }

    private isFutureDate(dateStr: string): boolean {
        return !!dateStr && dateStr > this.getTodayStr();
    }

    private findClosingDay(dateStr: string): any | null {
        return this.weekClosingStatus.find((day: any) => day.date === dateStr) || null;
    }

    private getDateObject(dateStr: string): Date {
        const target = dateStr || this.getTodayStr();
        const parts = target.split('-').map((value) => parseInt(value, 10));
        return new Date(parts[0], (parts[1] || 1) - 1, parts[2] || 1);
    }

    private getMonthString(dateStr: string): string {
        const target = dateStr || this.getTodayStr();
        return target.slice(0, 7);
    }

    private normalizeClosingCalendarDate(value: any): string {
        if (!value) return '';
        if (typeof value === 'string') return value.slice(0, 10);
        if (value instanceof Date) return this.formatDateKey(value);
        const parsed = new Date(value);
        if (!Number.isNaN(parsed.getTime())) return this.formatDateKey(parsed);
        return String(value).slice(0, 10);
    }

    private buildClosingCalendarFallbackDay(dateStr: string): any {
        const isFuture = dateStr > this.getTodayStr();
        return {
            date: dateStr,
            opened: false,
            closed: false,
            openedAt: '',
            openedBy: '',
            closedAt: '',
            closedBy: '',
            openingCash: 0,
            salesTotal: 0,
            discountTotal: 0,
            paymentCount: 0,
            approvalCount: 0,
            cashIn: 0,
            cashOut: 0,
            cashIoCount: 0,
            statusKey: isFuture ? 'future' : 'not-opened',
            statusLabel: isFuture ? '예정' : '미개점',
            statusTone: 'muted',
            checklist: [
                { key: 'open', label: '개점', done: false, meta: isFuture ? '예정 영업일' : '개점 전' },
                { key: 'sales', label: '매출 집계', done: false, meta: isFuture ? '예정 영업일' : '영업 전' },
                { key: 'close', label: '영업마감', done: false, meta: isFuture ? '예정 영업일' : '개점 후 가능' },
            ],
            issues: [
                {
                    key: isFuture ? 'future' : 'not_opened',
                    label: isFuture ? '미래 날짜는 마감 대상이 아닙니다.' : '개점 전이라 마감할 수 없습니다.',
                    tone: 'muted',
                    actionable: false,
                    action: '',
                },
            ],
            canClose: false,
            canView: !isFuture,
        };
    }

    private buildClosingCalendarFallbackDays(month: string): any[] {
        const base = this.getDateObject(`${month || this.getMonthString(this.getTodayStr())}-01`);
        const year = base.getFullYear();
        const monthIndex = base.getMonth();
        const lastDay = new Date(year, monthIndex + 1, 0).getDate();
        const days: any[] = [];
        for (let day = 1; day <= lastDay; day++) {
            days.push(this.buildClosingCalendarFallbackDay(this.formatDateKey(new Date(year, monthIndex, day))));
        }
        return days;
    }

    private summarizeClosingCalendarDays(days: any[]): any {
        const summary = { pending: 0, closed: 0, unopened: 0, future: 0 };
        days.forEach((day: any) => {
            if (day.statusKey === 'opened') summary.pending += 1;
            else if (day.statusKey === 'closed') summary.closed += 1;
            else if (day.statusKey === 'future') summary.future += 1;
            else summary.unopened += 1;
        });
        return summary;
    }

    private normalizeClosingCalendarDays(days: any[], month: string): any[] {
        const fallbackDays = this.buildClosingCalendarFallbackDays(month);
        const normalizedMap = new Map<string, any>();
        (days || []).forEach((day: any) => {
            const date = this.normalizeClosingCalendarDate(day?.date);
            if (!date) return;
            const fallback = this.buildClosingCalendarFallbackDay(date);
            normalizedMap.set(date, {
                ...fallback,
                ...day,
                date,
                opened: !!day?.opened,
                closed: !!day?.closed,
                openedAt: day?.openedAt || '',
                openedBy: day?.openedBy || '',
                closedAt: day?.closedAt || '',
                closedBy: day?.closedBy || '',
                openingCash: Number(day?.openingCash || 0),
                salesTotal: Number(day?.salesTotal || 0),
                discountTotal: Number(day?.discountTotal || 0),
                paymentCount: Number(day?.paymentCount || 0),
                approvalCount: Number(day?.approvalCount || 0),
                cashIn: Number(day?.cashIn || 0),
                cashOut: Number(day?.cashOut || 0),
                cashIoCount: Number(day?.cashIoCount || 0),
                statusKey: day?.statusKey || fallback.statusKey,
                statusLabel: day?.statusLabel || fallback.statusLabel,
                statusTone: day?.statusTone || fallback.statusTone,
                checklist: Array.isArray(day?.checklist) ? day.checklist : fallback.checklist,
                issues: Array.isArray(day?.issues) ? day.issues : fallback.issues,
                canClose: !!day?.canClose,
                canView: day?.canView === undefined ? fallback.canView : !!day.canView,
            });
        });
        return fallbackDays.map((fallback: any) => normalizedMap.get(fallback.date) || fallback);
    }

    public getClosingCalendarDayNumber(day: any): string {
        const date = this.normalizeClosingCalendarDate(day?.date);
        if (!date) return '-';
        const parts = date.split('-');
        if (parts.length !== 3) return date;
        return String(parseInt(parts[2], 10));
    }

    public getClosingCalendarMonthLabel(): string {
        if (!this.closingCalendarMonth) return '';
        const parts = this.closingCalendarMonth.split('-');
        if (parts.length !== 2) return this.closingCalendarMonth;
        return `${parts[0]}년 ${parseInt(parts[1], 10)}월`;
    }

    public isClosingCalendarNextDisabled(): boolean {
        return !this.closingCalendarMonth || this.closingCalendarMonth >= this.getMonthString(this.getTodayStr());
    }

    public getClosingCalendarWeeks(): any[] {
        if (this.closingCalendarDays.length === 0) return [];
        const firstDay = this.getDateObject(this.closingCalendarDays[0].date).getDay();
        const cells: any[] = [];
        for (let i = 0; i < firstDay; i++) cells.push(null);
        this.closingCalendarDays.forEach((day: any) => cells.push(day));
        while (cells.length % 7 !== 0) cells.push(null);
        const weeks: any[] = [];
        for (let i = 0; i < cells.length; i += 7) {
            weeks.push(cells.slice(i, i + 7));
        }
        return weeks;
    }

    public getClosingCalendarSelectedDay(): any | null {
        return this.closingCalendarDays.find((day: any) => day.date === this.closingCalendarSelectedDate) || null;
    }

    public getClosingCalendarChecklist(): any[] {
        const day = this.getClosingCalendarSelectedDay();
        return day ? day.checklist || [] : [];
    }

    public getClosingCalendarIssues(): any[] {
        const day = this.getClosingCalendarSelectedDay();
        return day ? day.issues || [] : [];
    }

    private async loadClosingCalendar(month?: string, selectedDate?: string) {
        const targetDate = selectedDate || this.closingCalendarSelectedDate || this.selectedClosingDate || this.getTodayStr();
        const targetMonth = month || this.closingCalendarMonth || this.getMonthString(targetDate);
        const fallbackDays = this.buildClosingCalendarFallbackDays(targetMonth);
        const fallbackSelectedDate = fallbackDays.some((day: any) => day.date === targetDate)
            ? targetDate
            : (fallbackDays[0]?.date || targetDate);

        this.closingCalendarMonth = targetMonth;
        this.closingCalendarSelectedDate = fallbackSelectedDate;
        this.closingCalendarDays = fallbackDays;
        this.closingCalendarSummary = this.summarizeClosingCalendarDays(fallbackDays);

        let res = await wiz.call("closing_calendar", {
            month: targetMonth,
            selectedDate: targetDate,
        });
        if (res.code === 200) {
            const resolvedMonth = res.data.month || targetMonth;
            const resolvedDays = this.normalizeClosingCalendarDays(res.data.days || [], resolvedMonth);
            const resolvedSelectedDate = this.normalizeClosingCalendarDate(res.data.selectedDate || fallbackSelectedDate) || fallbackSelectedDate;

            this.closingCalendarMonth = resolvedMonth;
            this.closingCalendarSelectedDate = resolvedSelectedDate;
            this.closingCalendarDays = resolvedDays;
            this.closingCalendarSummary = res.data.summary || this.summarizeClosingCalendarDays(resolvedDays);
        }
    }

    public async openClosingCalendar() {
        const targetDate = this.selectedClosingDate || this.getTodayStr();
        this.closingCalendarSelectedDate = targetDate;
        this.closingCalendarMonth = this.getMonthString(targetDate);
        this.activeModal = 'closingCalendar';
        this.closingCalendarDays = this.buildClosingCalendarFallbackDays(this.closingCalendarMonth);
        this.closingCalendarSummary = this.summarizeClosingCalendarDays(this.closingCalendarDays);
        await this.service.render();
        await this.loadClosingCalendar(this.closingCalendarMonth, targetDate);
        await this.service.render();
    }

    public async moveClosingCalendarMonth(offset: number) {
        const base = this.getDateObject(`${this.closingCalendarMonth || this.getMonthString(this.getTodayStr())}-01`);
        base.setMonth(base.getMonth() + offset);
        const nextMonth = `${base.getFullYear()}-${String(base.getMonth() + 1).padStart(2, '0')}`;
        if (nextMonth > this.getMonthString(this.getTodayStr())) return;

        const currentDay = this.getDateObject(this.closingCalendarSelectedDate || this.selectedClosingDate || this.getTodayStr()).getDate();
        const lastDay = new Date(base.getFullYear(), base.getMonth() + 1, 0).getDate();
        const targetDate = new Date(base.getFullYear(), base.getMonth(), Math.min(currentDay, lastDay));
        await this.loadClosingCalendar(nextMonth, this.formatDateKey(targetDate));
        await this.service.render();
    }

    public async selectClosingCalendarDate(day: any) {
        if (!day || !day.date) return;
        this.closingCalendarSelectedDate = day.date;
        await this.service.render();
    }

    public async applyClosingCalendarDate(date?: string) {
        const targetDate = date || this.closingCalendarSelectedDate;
        if (!targetDate) return;
        this.selectedClosingDate = targetDate;
        await this.loadWeekClosingStatus(targetDate);
        await this.loadClosingData();
        this.activeModal = '';
        await this.service.render();
    }

    public async openClosingFromCalendar(date?: string) {
        const targetDate = date || this.closingCalendarSelectedDate;
        if (!targetDate) return;
        await this.applyClosingCalendarDate(targetDate);
        await this.showCloseConfirm();
    }

    public async handleClosingCalendarIssue(issue: any) {
        if (!issue || !issue.actionable) return;
        if (issue.action === 'close') {
            await this.openClosingFromCalendar();
        }
    }

    // ═══════ 섹션 전환 ═══════
    private async handleMenuAction(action: string) {
        const sectionMap: { [key: string]: string } = {
            '마감정산': 'closing',
            '준비금등록': 'cashPrep',
            '시재점검': 'cashCheck',
            '사원근태': 'attendance',
            '마감취소': 'cancelClose',
            '외상입금': 'creditDeposit',
            '판매원변경': 'changeSeller',
            '기사출금': 'driverWithdraw',
            '전자상품권': 'eGiftCert',
            '시재입출금': 'cashInOut',
            '상품권판매': 'giftCertSale',
            '중간정산': 'midClose',
            '공지사항': 'notice',
            '매출 I/F': 'salesIF',
        };
        const section = sectionMap[action];
        if (section === 'eGiftCert') {
            this.activeModal = 'eGiftCert';
        } else if (section) {
            this.currentSection = section;
            if (section === 'closing') {
                this.closingPage = 1;
                this.selectedClosingDate = this.getTodayStr();
                await this.loadWeekClosingStatus();
                await this.loadClosingData();
            }
            if (section === 'cashInOut') {
                await this.loadCashIO();
            }
            if (section === 'giftCertSale') {
                await this.loadGiftTypes();
            }
            if (section === 'cashCheck') {
                await this.loadClosingData();
            }
        }
        await this.service.render();
    }

    public async goBackSection() {
        this.currentSection = '';
        this.activeModal = '';
        await this.service.render();
    }

    public async closeModal() {
        this.activeModal = '';
        await this.service.render();
    }

    goBack() {
        if (this.currentSection) {
            this.goBackSection();
        } else {
            this.service.href('/pos');
        }
    }

    // ═══════ 대시보드 차트 ═══════
    async selectChartType(key: string) { this.selectedChart = key; await this.service.render(); }
    async selectPeriod(key: string) { this.selectedPeriod = key; await this.loadChartData(); await this.service.render(); }

    async loadChartData() {
        let res = await wiz.call("chart_data", { period: this.selectedPeriod });
        if (res.code === 200 && res.data.data && res.data.data.length > 0) {
            this.chartData = this.normalizeChartData(res.data.data || []);
        } else {
            this.chartData = this.normalizeChartData([]);
        }
        this.maxValue = Math.max(...this.chartData.map(d => d.value), 1);
    }

    private normalizeChartData(rows: any[]): { label: string; value: number }[] {
        const normalized = (rows || []).map((row: any) => ({
            label: String(row.label || ''),
            value: Number(row.value) || 0,
        }));
        const valueMap = new Map(normalized.map((row) => [row.label, row.value]));
        const now = new Date();

        if (this.selectedPeriod === 'daily') {
            const result: { label: string; value: number }[] = [];
            for (let offset = 6; offset >= 0; offset--) {
                const date = new Date(now);
                date.setDate(now.getDate() - offset);
                const key = this.formatDateKey(date);
                const label = `${date.getMonth() + 1}/${date.getDate()}`;
                result.push({ label, value: valueMap.get(key) || 0 });
            }
            return result;
        }

        if (this.selectedPeriod === 'weekly') {
            const result: { label: string; value: number }[] = [];
            for (let offset = 3; offset >= 0; offset--) {
                const date = new Date(now);
                date.setDate(now.getDate() - (offset * 7));
                const key = this.formatWeekKey(date);
                result.push({ label: `${4 - offset}주`, value: valueMap.get(key) || 0 });
            }
            return result;
        }

        const result: { label: string; value: number }[] = [];
        for (let offset = 11; offset >= 0; offset--) {
            const date = new Date(now.getFullYear(), now.getMonth() - offset, 1);
            const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
            result.push({ label: `${date.getMonth() + 1}월`, value: valueMap.get(key) || 0 });
        }
        return result;
    }

    private formatDateKey(date: Date): string {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    }

    private formatWeekKey(date: Date): string {
        const target = new Date(date.valueOf());
        const dayNr = (date.getDay() + 6) % 7;
        target.setDate(target.getDate() - dayNr + 3);
        const firstThursday = new Date(target.getFullYear(), 0, 4);
        const firstDayNr = (firstThursday.getDay() + 6) % 7;
        firstThursday.setDate(firstThursday.getDate() - firstDayNr + 3);
        const weekNo = 1 + Math.round((target.getTime() - firstThursday.getTime()) / 604800000);
        return `${target.getFullYear()}-W${String(weekNo).padStart(2, '0')}`;
    }

    barPct(v: number): number { return Math.round((v / this.maxValue) * 100); }

    gridLines(): { value: number; label: string }[] {
        const steps = 5;
        const lines: { value: number; label: string }[] = [];
        for (let i = 0; i <= steps; i++) {
            const value = Math.round((this.maxValue / steps) * i);
            lines.push({ value, label: this.formatAmount(value) });
        }
        return lines;
    }

    linePoints(): string {
        if (!this.chartData.length) return '';
        const w = 460, h = 200, pad = 20;
        const step = w / (this.chartData.length - 1 || 1);
        return this.chartData.map((d, i) => {
            const x = pad + i * step;
            const y = h - (d.value / this.maxValue) * 170 - 10;
            return `${x},${y}`;
        }).join(' ');
    }

    lineAreaPath(): string {
        if (!this.chartData.length) return '';
        const w = 460, h = 200, pad = 20;
        const step = w / (this.chartData.length - 1 || 1);
        let path = `M ${pad},${h}`;
        this.chartData.forEach((d, i) => { const x = pad + i * step; const y = h - (d.value / this.maxValue) * 170 - 10; path += ` L ${x},${y}`; });
        path += ` L ${pad + (this.chartData.length - 1) * step},${h} Z`;
        return path;
    }

    lineCircles(): { cx: number; cy: number; label: string; value: string }[] {
        const w = 460, h = 200, pad = 20;
        const step = w / (this.chartData.length - 1 || 1);
        return this.chartData.map((d, i) => ({
            cx: pad + i * step, cy: h - (d.value / this.maxValue) * 170 - 10,
            label: d.label, value: this.formatAmount(d.value),
        }));
    }

    pieSlices(): { offset: number; pct: number; color: string; label: string; pctLabel: string }[] {
        const total = this.chartData.reduce((s, d) => s + d.value, 0) || 1;
        const colors = ['#4a9eff','#34c759','#ff9500','#af52de','#ff3b30','#5ac8fa','#ffcc00','#ff2d55','#8e8e93','#30b0c7','#ff6482','#a2845e'];
        let offset = 0;
        return this.chartData.map((d, i) => {
            const pct = (d.value / total) * 100;
            const s = { offset, pct, color: colors[i % colors.length], label: d.label, pctLabel: pct.toFixed(1) + '%' };
            offset += pct; return s;
        });
    }

    pieTotalLabel(): string {
        const total = this.chartData.reduce((s, d) => s + d.value, 0);
        return this.formatAmount(total);
    }

    // ═══════ 마감현황 (이번주) ═══════
    private async loadWeekClosingStatus(baseDate?: string) {
        const targetDate = baseDate || this.selectedClosingDate || this.getTodayStr();
        let res = await wiz.call("week_closing_status", { baseDate: targetDate });
        if (res.code === 200) {
            this.weekClosingStatus = res.data.days || [];
        }
    }

    public async onClosingDatePicked(date: string) {
        if (!date || this.isFutureDate(date)) return;
        this.selectedClosingDate = date;
        await this.loadWeekClosingStatus(date);
        await this.loadClosingData();
        await this.service.render();
    }

    public async selectClosingDay(day: any) {
        if (!day.opened) return;
        this.selectedClosingDate = day.date;
        await this.loadWeekClosingStatus(day.date);
        await this.loadClosingData();
        await this.service.render();
    }

    public getWeekdayLabel(dateStr: string): string {
        const d = new Date(dateStr);
        const days = ['일', '월', '화', '수', '목', '금', '토'];
        return days[d.getDay()];
    }

    public getShortDate(dateStr: string): string {
        if (!dateStr) return '-';
        const parts = dateStr.split('-');
        if (parts.length !== 3) return dateStr;
        return `${parseInt(parts[1])}/${parseInt(parts[2])}`;
    }

    public getTodayMaxDate(): string {
        return this.getTodayStr();
    }

    public getWeekRangeLabel(): string {
        if (this.weekClosingStatus.length === 0) return '';
        const start = this.weekClosingStatus[0]?.date || '';
        const end = this.weekClosingStatus[this.weekClosingStatus.length - 1]?.date || '';
        if (!start || !end) return '';
        return `${this.getShortDate(start)} - ${this.getShortDate(end)}`;
    }

    public getSelectedClosingState(): 'closed' | 'opened' | 'not-opened' | 'unknown' {
        const targetDate = this.selectedClosingDate || this.getTodayStr();
        const day = this.findClosingDay(targetDate);
        if (!day) return 'unknown';
        if (day.closed) return 'closed';
        if (day.opened) return 'opened';
        return 'not-opened';
    }

    public getSelectedClosingStatusLabel(): string {
        const state = this.getSelectedClosingState();
        if (state === 'closed') return '마감 완료';
        if (state === 'opened') return '미마감';
        if (state === 'not-opened') return '미개점';
        return '영업일 정보 없음';
    }

    // ═══════ 마감정산 ═══════
    private async loadClosingData() {
        const date = this.selectedClosingDate || this.getTodayStr();
        let res = await wiz.call("closing_data", { date });
        if (res.code === 200) {
            const d = res.data;
            this.closingPrepCash = d.openingCash || 0;
            this.closingCashSales = (d.payMethods?.['현금']?.total || 0);
            this.closingCashReturn = 0;
            this.closingCardApproval = (d.payMethods?.['카드']?.total || 0);
            this.closingCardCancel = 0;
            this.approvalList = (d.approvals || []).map((a: any, i: number) => ({
                no: i + 1, type: a.type, cardNo: a.card_no, amount: a.amount,
                approval: a.approval_no, time: a.time || '', status: a.status,
            }));

            const totalSales = d.totalSales || 0;
            const totalDiscount = d.totalDiscount || 0;
            const totalCount = d.totalCount || 0;
            const cashTotal = d.payMethods?.['현금']?.total || 0;
            const cardTotal = d.payMethods?.['카드']?.total || 0;
            const giftTotal = d.payMethods?.['상품권']?.total || 0;
            const creditTotal = d.payMethods?.['외상']?.total || 0;

            this.closingSummary1 = [
                { item: '총 매출', amount: totalSales }, { item: '순 매출', amount: totalSales - totalDiscount },
                { item: '할인 매출', amount: totalDiscount }, { item: '봉사료', amount: 0 },
                { item: '부가세', amount: Math.round(totalSales * 0.1) },
                { item: '과세 매출', amount: Math.round(totalSales * 0.9) },
                { item: '면세 매출', amount: Math.round(totalSales * 0.1) },
            ];
            this.closingSummary2 = [
                { item: '총 건수', count: totalCount }, { item: '정상 건수', count: totalCount },
                { item: '취소 건수', count: 0 }, { item: '할인 건수', count: 0 }, { item: '반품 건수', count: 0 },
            ];
            this.closingPayMethod = [
                { item: '현금', amount: cashTotal }, { item: '신용카드', amount: cardTotal },
                { item: '상품권', amount: giftTotal }, { item: '외상', amount: creditTotal }, { item: '기타', amount: 0 },
            ];
            this.closingDiscount = [
                { item: '임의할인', amount: 0 }, { item: '쿠폰할인', amount: 0 },
                { item: '회원할인', amount: 0 }, { item: '기타할인', amount: 0 },
            ];
            this.closingCardCompany = [];
            this.closingMemberSales = [
                { item: '회원 매출', amount: 0 }, { item: '비회원 매출', amount: totalSales },
            ];
            this.closingNonSales = [
                { item: '시재입금', amount: d.cashIn || 0 }, { item: '시재출금', amount: d.cashOut || 0 },
                { item: '준비금', amount: d.openingCash || 0 },
            ];
            this.closingChannelSales = [
                { item: '매장 매출', amount: totalSales }, { item: '배달 매출', amount: 0 },
            ];

            // 시재점검용
            this.checkSalesTotal = totalSales;
            this.checkSalesDiscount = totalDiscount;
            this.checkPayCash = cashTotal;
            this.checkPayCard = cardTotal;
            this.checkPayGift = giftTotal;
            this.checkPayCredit = creditTotal;
        }
    }

    async closingNext() { this.closingPage = 2; await this.service.render(); }
    async closingPrev() { this.closingPage = 1; await this.service.render(); }

    async openApprovalModal() { this.activeModal = 'approval'; await this.service.render(); }
    async setApprovalFilter(f: string) { this.approvalFilter = f; await this.service.render(); }
    async setApprovalTypeFilter(f: string) { this.approvalTypeFilter = f; await this.service.render(); }

    get filteredApprovals(): any[] {
        return this.approvalList.filter(a => {
            if (this.approvalFilter !== '전체') {
                if (this.approvalFilter === '신용카드' && a.type !== '신용카드') return false;
                if (this.approvalFilter === '현금영수증' && a.type !== '현금영수증') return false;
            }
            if (this.approvalTypeFilter !== '전체') {
                if (this.approvalTypeFilter === '매출' && a.status !== '승인') return false;
                if (this.approvalTypeFilter === '반품' && a.status !== '취소') return false;
            }
            return true;
        });
    }

    async registerClosingCash() {
        this.activeModal = 'closingCashRegistered';
        await this.service.render();
    }

    async showCloseConfirm() {
        this.closeConfirmId = '';
        this.closeConfirmPw = '';
        this.closeConfirmNotice = '';
        this.closeConfirmError = '';
        const targetDate = this.selectedClosingDate || this.getTodayStr();
        const selectedDay = this.findClosingDay(targetDate);
        if (this.isFutureDate(targetDate)) {
            this.closeConfirmNotice = '미래 날짜는 마감할 수 없습니다.';
        } else if (selectedDay && !selectedDay.opened) {
            this.closeConfirmNotice = '선택한 영업일이 아직 개점되지 않았습니다.';
        } else if (selectedDay && selectedDay.closed) {
            this.closeConfirmNotice = '이미 마감된 영업일입니다.';
        }
        this.activeModal = 'closeConfirm';
        await this.service.render();
    }

    async doBusinessClose() {
        const targetDate = this.selectedClosingDate || this.getTodayStr();
        if (this.closeConfirmNotice) {
            return;
        }
        if (this.isFutureDate(targetDate)) {
            this.closeConfirmError = '미래 날짜는 마감할 수 없습니다.';
            await this.service.render();
            return;
        }
        let res = await wiz.call("close_business_by_date", {
            staffId: this.closeConfirmId,
            staffPw: this.closeConfirmPw,
            date: targetDate,
        });
        if (res.code !== 200) {
            this.closeConfirmError = res.data?.message || '아이디 또는 비밀번호가 일치하지 않습니다.';
            await this.service.render();
            return;
        }

        // localStorage 업데이트
        const now = new Date();
        const timeStr = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;
        if (targetDate === this.getTodayStr()) {
            const bd = this.getBusinessDay() || {};
            bd.closed = true;
            bd.closedDate = targetDate;
            bd.closedTime = timeStr;
            bd.closedBy = `${this.closeConfirmId}`;
            localStorage.setItem('pos-business-day', JSON.stringify(bd));
        }

        await this.loadWeekClosingStatus(targetDate);
        await this.loadClosingData();

        // 마감 완료 모달 표시
        this.closingCompleteDate = targetDate;
        this.activeModal = 'closingComplete';
        await this.service.render();
    }

    public async onClosingCompleteConfirm() {
        this.activeModal = '';
        this.service.href('/pos');
    }

    // ═══════ 준비금등록 ═══════
    async doPrepRegister() {
        await wiz.call("register_prep", {
            amount: parseInt(this.prepAmount) || 0,
            date: this.prepDate,
        });
        const bd = this.getBusinessDay();
        if (bd) {
            bd.openingCash = parseInt(this.prepAmount) || 0;
            localStorage.setItem('pos-business-day', JSON.stringify(bd));
        }
        this.activeModal = 'prepRegistered';
        await this.service.render();
    }

    // ═══════ 사원근태 ═══════
    async attSearch() {
        let res = await wiz.call("staff_search", { staffNo: this.attNo });
        if (res.code === 200) {
            this.attName = res.data.staff.name;
            this.attStaffId = res.data.staff.id;
            this.attLastStatus = res.data.lastAttendance?.display || '기록 없음';
        } else {
            this.attName = '';
            this.attStaffId = '';
            this.attLastStatus = res.data?.message || '사원 정보를 찾을 수 없습니다.';
        }
        await this.service.render();
    }

    async attClockIn() {
        if (!this.attName || !this.attStaffId) return;
        let res = await wiz.call("attendance_clock", {
            staffId: this.attStaffId, staffName: this.attName, type: 'in'
        });
        if (res.code === 200) {
            this.attLastStatus = res.data.attendance?.display || '출근 처리됨';
        }
        await this.service.render();
    }

    async attClockOut() {
        if (!this.attName || !this.attStaffId) return;
        let res = await wiz.call("attendance_clock", {
            staffId: this.attStaffId, staffName: this.attName, type: 'out'
        });
        if (res.code === 200) {
            this.attLastStatus = res.data.attendance?.display || '퇴근 처리됨';
        }
        await this.service.render();
    }

    // ═══════ 마감취소 ═══════
    async doCancelClose() {
        const today = this.getTodayStr();
        await wiz.call("cancel_close", { date: today });
        const bd = this.getBusinessDay();
        if (bd && bd.closed) {
            bd.closed = false;
            bd.closedDate = null;
            bd.closedTime = null;
            bd.closedBy = null;
            localStorage.setItem('pos-business-day', JSON.stringify(bd));
        }
        this.activeModal = 'cancelDone';
        await this.service.render();
    }

    // ═══════ 외상입금 ═══════
    async creditSearch() {
        let res = await wiz.call("credit_search", {
            searchType: this.creditSearchType, value: this.creditSearchValue,
        });
        if (res.code === 200) {
            this.creditMemberId = res.data.member.id;
            this.creditMemberName = res.data.member.name;
            this.creditMemberPhone = res.data.member.phone;
            this.creditMemberBalance = res.data.member.balance;
            this.creditRecentHistory = (res.data.history || []).map((h: any) => ({
                date: h.date, type: h.type, amount: h.amount,
                balance: h.balance, note: h.method || '',
            }));
        } else {
            this.creditMemberId = 0;
            this.creditMemberName = '';
            this.creditMemberPhone = '';
            this.creditMemberBalance = 0;
            this.creditRecentHistory = [];
        }
        await this.service.render();
    }

    async selectCreditPayMethod(method: string) {
        this.creditPayMethod = method;
        await this.service.render();
    }

    async doCreditDeposit() {
        const amount = parseInt(this.creditAmount) || 0;
        if (amount <= 0 || !this.creditMemberId) return;
        let res = await wiz.call("credit_deposit", {
            memberId: this.creditMemberId, amount, method: this.creditPayMethod,
        });
        if (res.code === 200) {
            this.creditMemberBalance = res.data.balance;
            this.creditRecentHistory.unshift({
                date: this.getTodayStr(), type: '입금', amount: -amount,
                balance: this.creditMemberBalance, note: this.creditPayMethod,
            });
        }
        this.creditAmount = '';
        await this.service.render();
    }

    async creditRangeSearch() {
        if (!this.creditMemberId) return;
        let res = await wiz.call("credit_history", {
            memberId: this.creditMemberId,
            start: this.creditDateStart, end: this.creditDateEnd,
        });
        if (res.code === 200) {
            this.creditRangeHistory = (res.data.list || []).map((h: any) => ({
                date: h.date, type: h.type, amount: h.amount,
                balance: h.balance, note: h.method || '',
            }));
        }
        await this.service.render();
    }

    // ═══════ 판매원변경 ═══════
    async sellerSearch() {
        let res = await wiz.call("change_seller", {
            newId: this.sellerNewNo, newPw: this.sellerNewPw,
        });
        if (res.code === 200) {
            this.sellerNewName = res.data.staff.name;
            this.sellerNewRole = res.data.staff.role || 'staff';
        } else {
            this.sellerNewName = '일치하는 사원이 없습니다.';
            this.sellerNewRole = 'staff';
        }
        await this.service.render();
    }

    async doChangeSeller() {
        if (!this.sellerNewName || this.sellerNewName.includes('없습니다')) return;
        const auth = { id: this.sellerNewNo, name: this.sellerNewName };
        localStorage.setItem('pos-auth', JSON.stringify({
            loggedIn: true, id: auth.id, name: auth.name,
            role: this.sellerNewRole,
            loginTime: new Date().toISOString(),
        }));
        this.sellerOldNo = auth.id;
        this.sellerOldName = auth.name;
        this.sellerNewNo = '';
        this.sellerNewPw = '';
        this.sellerNewName = '';
        this.sellerNewRole = 'staff';
        this.activeModal = 'sellerChanged';
        await this.service.render();
    }

    // ═══════ 기사출금 ═══════
    async driverSearch() {
        let res = await wiz.call("driver_search", { name: this.driverSearchName });
        if (res.code === 200) {
            const d = res.data.driver;
            this.driverId = d.id;
            this.driverName = d.name;
            this.driverCar = d.car_no;
            this.driverPhone = d.phone;
            this.driverMobile = d.mobile;
        } else {
            this.driverId = 0;
            this.driverName = '';
        }
        await this.service.render();
    }

    async driverReceiptSearch() {
        this.driverBizDate = this.driverReceiptDate;
        this.driverPosNo = '001';
        this.driverReceiptNoInfo = this.driverReceiptNo || 'R-001';
        this.driverPayAmount = 35000;
        this.driverWithdrawAmount = 0;
        if (this.driverId) {
            let res = await wiz.call("driver_history", {
                driverId: this.driverId, date: this.driverReceiptDate,
            });
            if (res.code === 200) {
                this.driverDayHistory = (res.data.list || []).map((h: any, i: number) => ({
                    no: i + 1, receiptNo: h.receipt_no, date: h.biz_date,
                    amount: h.amount, status: h.status,
                }));
            }
        }
        await this.service.render();
    }

    async doDriverWithdraw() {
        if (!this.driverId) return;
        await wiz.call("driver_withdraw", {
            driverId: this.driverId, amount: this.driverPayAmount,
            receiptNo: this.driverReceiptNoInfo,
            bizDate: this.driverBizDate || this.getTodayStr(),
        });
        this.driverWithdrawAmount = this.driverPayAmount;
        this.driverDayHistory.push({
            no: this.driverDayHistory.length + 1,
            receiptNo: this.driverReceiptNoInfo,
            date: this.getTodayStr(),
            amount: this.driverPayAmount,
            status: '출금완료',
        });
        await this.service.render();
    }

    async doDriverWithdrawCancel() {
        this.driverWithdrawAmount = 0;
        await this.service.render();
    }

    // ═══════ 시재입출금 ═══════
    private async loadCashIO() {
        let res = await wiz.call("cashio_load", { date: this.cashIODate || this.getTodayStr() });
        if (res.code === 200) {
            this.cashIOHistory = (res.data.list || []).map((h: any, i: number) => ({
                ...h, no: i + 1,
                type: h.type === 'in' ? '입금' : '출금',
                time: h.time || '',
            }));
        }
    }

    async selectCashIOType(type: 'in' | 'out') {
        this.cashIOType = type;
        await this.service.render();
    }

    async doCashIORegister() {
        const amount = parseInt(this.cashIOAmount) || 0;
        if (amount <= 0) return;
        await wiz.call("cashio_register", {
            bizDate: this.cashIODate || this.getTodayStr(),
            type: this.cashIOType,
            amount, account: this.cashIOAccount || '-',
            memo: this.cashIOMemo || '-',
        });
        await this.loadCashIO();
        this.cashIOAmount = '';
        this.cashIOAccount = '';
        this.cashIOMemo = '';
        await this.service.render();
    }

    async doCashIODelete(idx: number) {
        const item = this.cashIOHistory[idx];
        if (item && item.id) {
            await wiz.call("cashio_delete", { id: item.id });
        }
        await this.loadCashIO();
        await this.service.render();
    }

    // ═══════ 상품권판매 ═══════
    private async loadGiftTypes() {
        let res = await wiz.call("gift_types");
        if (res.code === 200) {
            this.giftCertTypes = (res.data.list || []).map((g: any) => ({
                id: g.id, name: g.name, face: g.face_value,
            }));
        }
    }

    async giftCarouselPrev() {
        if (this.giftCarouselPage > 0) this.giftCarouselPage--;
        await this.service.render();
    }

    async giftCarouselNext() {
        if (this.giftCarouselPage < this.giftCarouselMax) this.giftCarouselPage++;
        await this.service.render();
    }

    async addGiftToCart(item: any) {
        const existing = this.giftCart.find(c => c.name === item.name);
        if (existing) { existing.qty++; existing.amount = existing.face * existing.qty - existing.discount; }
        else { this.giftCart.push({ no: this.giftCart.length + 1, name: item.name, face: item.face, qty: 1, discount: 0, amount: item.face, memo: '' }); }
        await this.service.render();
    }

    async giftQtyChange(idx: number, delta: number) {
        this.giftCart[idx].qty = Math.max(1, this.giftCart[idx].qty + delta);
        this.giftCart[idx].amount = this.giftCart[idx].face * this.giftCart[idx].qty - this.giftCart[idx].discount;
        await this.service.render();
    }

    async giftRemoveItem(idx: number) {
        this.giftCart.splice(idx, 1);
        this.giftCart.forEach((g, i) => g.no = i + 1);
        await this.service.render();
    }

    async giftClearAll() {
        this.giftCart = [];
        this.giftPaidAmount = 0;
        this.giftPayHistory = [];
        await this.service.render();
    }

    async giftPay(method: string) {
        if (this.giftCartPayable <= 0) return;
        await wiz.call("gift_pay", {
            bizDate: this.getTodayStr(),
            items: JSON.stringify(this.giftCart.map(g => ({
                id: 0, name: g.name, face: g.face, qty: g.qty,
                discount: g.discount, amount: g.amount,
            }))),
            method,
        });
        this.giftPaidAmount += this.giftCartPayable;
        this.giftPayHistory.push({
            no: this.giftPayHistory.length + 1,
            method, amount: this.giftCartPayable,
            time: new Date().toLocaleTimeString('ko-KR'),
        });
        this.giftPayTab = 'history';
        await this.service.render();
    }

    // ═══════ 포맷 ═══════
    formatAmount(v: number): string {
        if (v >= 10000) return (v / 10000).toFixed(0) + '만';
        return v.toLocaleString();
    }

    formatCurrency(v: number): string { return (v || 0).toLocaleString(); }

    formatDateLabel(dateStr: string): string {
        if (!dateStr) return '-';
        const parts = dateStr.split('-');
        if (parts.length !== 3) return dateStr;
        return `${parseInt(parts[1])}월 ${parseInt(parts[2])}일`;
    }
}

export default PagePosBusinessComponent;